import { CRUDProvider } from 'components/providers';
import { useTranslation } from 'react-i18next';
import { ValuationResources } from 'services/resources/deal-flow/valuation';

import { Page } from './components/Page';

export const ValuationPage: React.FC = (): JSX.Element => {
  const { t } = useTranslation('valuations');

  return (
    <CRUDProvider
      allowPost
      quote={t('page.quote')}
      resource={ValuationResources}
      title={t('page.title')}
    >
      <Page />
    </CRUDProvider>
  );
};
